import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DictionaryType } from 'helper/types';
import { DatasourceStatuesType, DatasourceType, StationFullType } from 'Services/api/v2';
import { AppState } from '../store';

export type DictionariesSliceState = {
  /** к ключу stationId принадлежит объект станции и айди источников */
  stationsFull: DictionaryType<StationFullType>,
  /** к ключу datasourceId принадлежит объект источников */
  datasources: DictionaryType<DatasourceType>,
  /** к ключу datasourceId принадлежит объект статусов */
  datasourceStatuses: DictionaryType<DatasourceStatuesType>,
  // индикация загрузки станции с вебсокета
  isFetchingStation: boolean,
  // индикация загрузки источника с вебсокета
  isFetchingDatasource: boolean,
  // индикация загрузки статуса источника с вебсокета
  isFetchingDatasourceStatus: boolean,
}

const initialState: DictionariesSliceState = {
  stationsFull: {},
  datasources: {},
  datasourceStatuses: {},
  isFetchingStation: false,
  isFetchingDatasource: false,
  isFetchingDatasourceStatus: false,
};

export const DICTIONARIES_SLICE = 'dictionaries';

export const dictionariesSlice = createSlice({
  name: DICTIONARIES_SLICE,
  initialState,
  reducers: {
    setStationsFull: (state, { payload }: PayloadAction<DictionariesSliceState['stationsFull']>) => {
      if (Object.keys(payload).length > 0) state.stationsFull = payload;
      else state.stationsFull = initialState.stationsFull;
    },
    // TODO: проверить удаление (Макс сказал подумает)
    /** по stationId */
    updateStationsFullById: (state, { payload }: PayloadAction<StationFullType>) => {
      state.stationsFull[payload.station.id] = payload;
    },
    setIsLoadingStationFull: (state, { payload }: PayloadAction<boolean>) => {
      state.isFetchingStation = payload;
    },

    setDatasources: (state, { payload }: PayloadAction<DictionariesSliceState['datasources']>) => {
      if (Object.keys(payload).length > 0) state.datasources = payload;
      else state.datasources = initialState.datasources;
    },
    // TODO: проверить удаление (Макс сказал подумает)
    /** по datasourcesId */
    updateDatasourceById: (state, { payload }: PayloadAction<DatasourceType>) => {
      state.datasources[payload.id] = payload;
      const index = state.stationsFull[payload.stationId].datasourceIds.indexOf(payload.id);
      if (index === -1) {
        state.stationsFull[payload.stationId].datasourceIds.push(payload.id);
      }
    },

    setIsLoadingDatasource: (state, { payload }: PayloadAction<boolean>) => {
      state.isFetchingDatasource = payload;
    },

    setDatasourceStatuses: (state, { payload }: PayloadAction<DictionariesSliceState['datasourceStatuses']>) => {
      if (Object.keys(payload).length > 0) state.datasourceStatuses = payload;
      else state.datasourceStatuses = initialState.datasourceStatuses;
    },
    // TODO: проверить удаление (Макс сказал подумает)
    /** по datasourceId */
    updateDatasourceStatusById: (state, { payload }: PayloadAction<DatasourceStatuesType>) => {
      if (payload.datasourceId || payload.datasourceId === 0) {
        state.datasourceStatuses[payload.datasourceId] = payload;
      }
    },

    setIsLoadingDatasourceStatus: (state, { payload }: PayloadAction<boolean>) => {
      state.isFetchingDatasourceStatus = payload;
    },

    deleteStationFullById: (state, { payload }: PayloadAction<number>) => {
      const datasources = state.stationsFull[payload].datasourceIds;
      datasources.forEach((datasourceId) => {
        deleteDatasource(state, datasourceId);
      });
      delete state.stationsFull[payload];
    },

    deleteDatasourceById: (state, { payload }: PayloadAction<number>) => {
      deleteDatasource(state, payload);
    },
  },
});
export default dictionariesSlice.reducer;

export * from './selectors';

export const {
  setStationsFull,
  updateStationsFullById,
  setIsLoadingStationFull,
  setDatasources,
  updateDatasourceById,
  setIsLoadingDatasource,
  setDatasourceStatuses,
  updateDatasourceStatusById,
  setIsLoadingDatasourceStatus,
  deleteDatasourceById,
  deleteStationFullById,
} = dictionariesSlice.actions;

export const isFetchingDisctionaryStationFullSelector = (state: AppState) => state.dictionaries.isFetchingStation;
export const isFetchingDisctionaryDatasourceSelector = (state: AppState) => state.dictionaries.isFetchingDatasource;
export const isFetchingDisctionaryDatasourceStatusSelector = (state: AppState) => state.dictionaries.isFetchingDatasourceStatus;

function deleteDatasource(state: DictionariesSliceState, id: number) {
  const { stationId } = state.datasources[id];
  delete state.datasources[id];
  if (state.datasourceStatuses[id]) {
    delete state.datasourceStatuses[id];
  }
  const index = state.stationsFull[stationId].datasourceIds.findIndex((datasourceId) => datasourceId === id);
  state.stationsFull[stationId].datasourceIds.splice(index, 1);
}
